export default {
    config: {
        apiKey: "AIzaSyC3JGdPrQNxOggbmEVZqmwMoIBLgwzuxdY",
        authDomain: "emalifychat.firebaseapp.com",
        databaseURL: "https://emalifychat.firebaseio.com",
        projectId: "emalifychat",
        storageBucket: "emalifychat.appspot.com",
        messagingSenderId: "677565980513",
        appId: "1:677565980513:web:b573e33bc1a9c7adddaf20",
        measurementId: "G-HK4C3BLF2N"
    }
}
